<template>
  <div>
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            Plataformas
          </span>
        </h3>
      </div>
      <div class="card-body">
        <b-row>
          <b-col style="max-width: 600px">
            <div class="border rounded p-5">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  gap: 20px;
                "
              >
                <a
                  href="https://www.vendizap.com"
                  target="_blank"
                  v-b-tooltip.hover.top="'Visitar Vendizap'"
                >
                  <img
                    alt="vendizap"
                    class="avatar-img"
                    src="https://www.vendizap.com/assets/img/logo.png"
                    width="300"
                  />
                </a>
                <button v-b-toggle.vendizap>
                  <Plus class="btn btn-secondary btn-hover-info btn-icon" />
                </button>
              </div>
              <b-collapse
                id="vendizap"
                accordion="clienteAcordion"
                role="tabpanel"
              >
                <b-card>
                  <b-row>
                    <b-col>
                      <b-form-group label="Cliente ID">
                        <b-form-input
                          v-model="vendizapClientId"
                          :disabled="vendizapIntegrated"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group label="Cliente Secret">
                        <b-form-input
                          v-model="vendizapClientSecret"
                          :disabled="vendizapIntegrated"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <button
                        @click="integrarVendizap"
                        ref="integrarVendizap"
                        class="btn btn-primary font-weight-bold mt-5"
                        :disabled="vendizapIntegrated"
                      >
                        Integrar
                      </button>
                    </b-col>
                    <b-col
                      v-if="vendizapIntegrated"
                      style="
                        display: flex;
                        align-items: end;
                        justify-content: end;
                        padding-right: 2rem;
                      "
                    >
                      <div class="">
                        <p
                          class="mb-0 text-success font-weight-bold"
                          style="font-size: 1.5rem"
                        >
                          Integrado!
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </div>
          </b-col>
          <!-- Bloco Asaas -->
          <b-col style="max-width: 700px">
            <div class="border rounded p-5">
              <div
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <a
                  href="https://www.asaas.com"
                  target="_blank"
                  v-b-tooltip.hover.top="'Asaas'"
                >
                  <img
                    alt="asaas"
                    class="avatar-img"
                    src="https://nuts.nyc3.digitaloceanspaces.com/asaas.jpg"
                    width="50"
                  />
                </a>
                <button v-b-toggle.subcontaAsaas>
                  <Plus class="btn btn-secondary btn-hover-info btn-icon" />
                </button>
              </div>

              <b-collapse
                id="subcontaAsaas"
                accordion="asaasAcordion"
                role="tabpanel"
              >
                <b-card>
                  <b-card>
                    <b-form-group label="Chave da API Asaas">
                      <b-form-input
                        v-model="asaasClientSecret"
                        placeholder="Informe a chave da API"
                      />
                    </b-form-group>
                  </b-card>

                  <b-button
                    class="mt-3"
                    variant="primary"
                    @click="integrarAsaas"
                    :disabled="carregandoSubconta"
                  >
                    <b-spinner small v-if="carregandoSubconta" class="mr-2" />
                    {{
                      asaasIntegrated
                        ? "Atualizar chave"
                        : "Integrar Conta Existente"
                    }}
                  </b-button>
                  <b-col
                    v-if="asaasIntegrated"
                    style="
                      display: flex;
                      align-items: end;
                      justify-content: end;
                      padding-right: 2rem;
                    "
                  >
                    <div class="">
                      <p
                        class="mb-0 text-success font-weight-bold"
                        style="font-size: 1.5rem"
                      >
                        Integrado!
                      </p>
                    </div>
                  </b-col>
                </b-card>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <div class="border-bottom border-light py-3">
          <b-col md="3"> </b-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import Plus from "vue-material-design-icons/PlusThick.vue";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "app-integracoes",
  data() {
    return {
      vendizapClientId: null,
      vendizapClientSecret: null,
      vendizapIntegrated: false,
      asaasClientSecret: null,
      asaasIntegrationId: null,
      asaasIntegrated: false,
      formSubconta: {
        nome: null,
        cnpj: null,
        email: null,
        telefone: null,
        cep: null,
        endereco: null,
        numero: null,
        bairro: null,
        faturamento: null,
      },
      carregandoSubconta: false,
      configMoney: settingMoney,
      tipoIntegracao: "nova",
    };
  },
  components: {
    Plus,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  created() {
    this.getDataInit();
  },
  methods: {
    async carregarDadosEmissor() {
      try {
        const response = await this.$http.post("/bancos/get-dados-emissor");
        const dados = response.data;

        this.formSubconta.nome = dados.nome;
        this.formSubconta.cnpj = dados.cnpj_cpf;
        this.formSubconta.email = dados.email;
        this.formSubconta.telefone = dados.fone;
        this.formSubconta.cep = dados.cep;
        this.formSubconta.endereco = dados.logradouro;
        this.formSubconta.numero = dados.numero;
        this.formSubconta.bairro = dados.bairro;
        this.formSubconta.complemento = dados.complemento || "";
      } catch (error) {
        console.error("Erro ao carregar dados do emissor:", error);
        this.$toast.warning("Não foi possível carregar os dados do emissor.", {
          variant: "warning",
          solid: true,
        });
      }
    },
    async criarSubconta() {
      this.carregandoSubconta = true;

      try {
        this.$http.post("/bancos/create-digital", this.formSubconta);
        this.$toast.success("Subconta criada com sucesso!");
        this.asaasIntegrated = true;
      } catch (e) {
        console.error(e);
        this.$toast.warning("Erro ao criar subconta.", {
          variant: "danger",
          solid: true,
        });
      } finally {
        this.carregandoSubconta = false;
        this.asaasIntegrated = true;
      }
    },
    async integrarVendizap() {
      this.addLoadingToButton("integrarVendizap");
      try {
        await this.$http.post("/integracao/create", {
          tipo: 1,
          client_id: this.vendizapClientId,
          client_secret: this.vendizapClientSecret,
        });
        this.$toast.success("Cadastrado com sucesso!");
        this.vendizapClientId = null;
        this.vendizapClientSecret = null;
        this.vendizapIntegrated = true;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("integrarVendizap");
    },
    async integrarAsaas() {
      if (!this.asaasClientSecret) {
        this.$toast.warning("Informe a chave da API!");
        return;
      }

      const atualizando = Boolean(this.asaasIntegrationId);
      this.carregandoSubconta = true;

      try {
        const payload = {
          tipo: 2,
          client_secret: this.asaasClientSecret,
        };

        if (atualizando) {
          payload.id_integracao = this.asaasIntegrationId;
        }

        const response = await this.$http.post(
          atualizando ? "/integracao/update" : "/integracao/create",
          payload
        );
        this.$toast.success(
          atualizando
            ? "Chave atualizada com sucesso!"
            : "Cadastrado com sucesso!"
        );
        this.asaasIntegrationId =
          response?.data?.data?.id_integracao ||
          response?.data?.id_integracao ||
          this.asaasIntegrationId;
        this.asaasClientSecret = null;
        this.asaasIntegrated = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.carregandoSubconta = false;
      }
    },
    async getDataInit() {
      try {
        const response = await this.$http.post("/integracao/get", { tipo: 1 });
        if (response?.data?.id_integracao) this.vendizapIntegrated = true;

        const responseAsaas = await this.$http.post("/integracao/get", {
          tipo: 2,
        });

        if (responseAsaas?.data?.id_integracao) {
          this.asaasIntegrationId = responseAsaas.data.id_integracao;
          this.asaasIntegrated = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.carregarDadosEmissor();
  },
  watch: {},
};
</script>
